// Based on https://github.com/alvarotrigo/fullPage.js/blob/f9cf07374d6af7c157d43b6e63c55f3105d6f519/src/fullpage.js#L1344

function average(elements, number) {
  const lastElements = elements.slice(Math.max(elements.length - number, 1));
  const sum = lastElements.reduce((s, val) => s + val, 0);
  return Math.ceil(sum / lastElements.length);
}

export default function wheelControl(presentations) {
  let scrolls = [];
  let prevTime = 0;
  let prevDirection = 0;
  let accelerated = false;

  function go(direction) {
    const { presentation } = presentations;
    if (direction === -1) {
      presentation.prev();
    } else {
      presentation.next();
    }
  }

  window.addEventListener('wheel', e => {
    const time = e.timeStamp;
    const value = e.deltaY;

    if (value === 0) {
      return;
    }

    const direction = value < 0 ? -1 : 1;
    const timeDiff = time - prevTime;

    if (timeDiff > 200 || direction !== prevDirection) {
      go(direction);
      scrolls = [Math.abs(value)];
      prevTime = time;
      prevDirection = direction;
      accelerated = true;
      return;
    }

    if (scrolls.length === 150) {
      scrolls.shift();
    }

    scrolls.push(Math.abs(value));

    const averageEnd = average(scrolls, 5);
    const averageMiddle = average(scrolls, 70);
    const isAccelerating = averageEnd >= averageMiddle;
    // console.log(averageMiddle, averageEnd, scrolls);

    if (isAccelerating && !accelerated) {
      go(direction);
      accelerated = true;
    }

    if (!isAccelerating && accelerated) {
      accelerated = false;
    }

    prevTime = time;
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/control/wheelControl.js